
/* eslint-disable */
const _local = 'local',
  _session = 'session';
// 设置session本地存储
export const setSession = (key, val) => {
  console.warn(
    `Session更新key:${key} > 值: `,
    val
  );
  return _setStorage(_session, key, val);
};
// 设置local本地存储
export const setLocal = (key, val) => _setStorage(_local, key, val);

// 获取session本地存储
export const getSession = key => _getStorage(_session, key);

/* 获取local本地存储 */
export const getLocal = key => _getStorage(_local, key);

/* 删除session本地存储 */
export const removeSession = key => _remove(_session, key);

/* 删除local本地存储 */
export const removeLocal = key => _remove(_local, key);
/* 
 用过key获取cookie
*/
export const getCookie = key => {
  let reg = new RegExp('(^|;\\s*)' + key + '=([^;]*)(;|$)'),
    matchedArr = document.cookie.match(reg);
  if (matchedArr && matchedArr[2]) {
    let data = '';
    try {
      data = JSON.parse(matchedArr[2]);
    } catch (error) {
      console.error(new Error(error));
    }
    return data;
  }
  return '';
};
/* 设置cookie
    days: 有效期默认关闭浏览器清空
*/
export const setCookie = (key, value, days = 0) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  document.cookie = key + '=' + (value || '') + expires + '; path=/';
}
/* 判断是否存在指定key的cookie */
export const hasCookie = (key) => !!getCookie(key);

// 本地存储操作
function _setStorage (type, key, val) {
  if (typeof val === 'object') {
    val = JSON.stringify(val);
  }
  window[`${type}Storage`].setItem(key, val);
};

// 存储获取
function _getStorage (type, key) {
  let str = window[`${type}Storage`].getItem(key) || '',
    data = '';
  try {
    data = JSON.parse(str);
  } catch (error) {
    data = str;
  }
  return data;
};

// 删除本地存储
function _remove (type, key) {
  window[`${type}Storage`].removeItem(key);
};
